export const emptyDate = "0001-01-01T00:00:00";

export function toUIDate(date) {   
    if (date == emptyDate)
        return null;
    
    if (!date)
        return date;
    if (date.indexOf('T') >= 0) {
        const tokens = date.split('T');
        return tokens[0];
    }

    return date;
}

export function twoDigit(value) {
    return value < 10 ? '0' + value : value;
}

export function toUIDateTime(date) {
    if (date == emptyDate)
        return null;

    if (!date)
        return date;

    if (date.indexOf('T') >= 0) {
        const d = new Date(date);

        const s = d.getFullYear() + '-' + twoDigit(d.getMonth() + 1) + '-' + twoDigit(d.getDate()) + 'T' + twoDigit(d.getHours()) + ':' + twoDigit(d.getMinutes());
        return s;
    }

    return date;
}

function formatDate(dateStr) {
    const date = new Date(dateStr);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${day}-${month}-${year}-${hours}:${minutes}:${seconds}`;
  }
 

export function autoCompleteFilialAndFilialDivision(authorizedEmployee, setFilialId, setFilialDivisionId) {
    if (authorizedEmployee?.filialId || authorizedEmployee?.filialDivisionId) {
        setFilialDivisionId(authorizedEmployee?.filialDivisionId);
        setFilialId(authorizedEmployee?.filialId);
    }
}

export function yearStart(year) {
    const date = new Date();
    if (!year) {
        year = date.getUTCFullYear();
    }

    return new Date(year, 0, 1, 0, 0, 0, 0);
}

export function yearEnd(year) {
    const date = new Date();
    if (!year) {
        year = date.getUTCFullYear();
    }
    const result = new Date(year + 1, 0, 1, 0, 0, 0, 0);
    result.setMilliseconds(result.getMilliseconds() - 1);
    return result;
}